import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BecomeACustomerSharedModule } from '@innogy/become-a-customer/shared';
import { SupplyAddressComponent } from '@innogy/become-a-customer/ui';
import { CommonUiFormsModule } from '@innogy/common-ui/forms';
import { GenericLightboxModule } from '@innogy/common-ui-modals';
import { CommonUiSharedModule } from '@legacy/common-ui-shared';
import { CommonUiUtilityComponentsModule } from '@legacy/common-ui-utility-components';
import { AnalyticsModule } from '@analytics/core';
import { CoreExperienceEditorComponentsModule } from '@core/experience-editor-components';
import { OfferMailer, offerSaverEffects } from '@innogy/offer-saver';
import { UtilsModule } from '@innogy/utils-deprecated';
import {
  CSCaptureDirective,
  CSMaskDirective,
} from '@legacy/utils-contentsquare';
import {
  NgbCarouselModule,
  NgbPopoverModule,
} from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { CommonUiPartialsModule } from '@legacy/common-ui-partials';
import { EffectsModule } from '@ngrx/effects';
import {
  HorizontalCommodityOfferComponent,
  VerticalCommodityOfferComponent,
  MixedCommodityOfferComponent,
} from '@innogy/commodity-offers';

import { AcquisitionCommodityOfferContainerComponent } from './acquisition-commodity-offer-container/acquisition-commodity-offer-container.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    CoreExperienceEditorComponentsModule,
    BecomeACustomerSharedModule,
    TranslatePipe,
    TranslateDirective,
    JssModule,
    CommonUiSharedModule,
    CommonUiUtilityComponentsModule,
    CommonUiFormsModule,
    UtilsModule,
    FontAwesomeModule,
    NgbPopoverModule,
    AnalyticsModule,
    NgbCarouselModule,
    SupplyAddressComponent,
    GenericLightboxModule,
    CSCaptureDirective,
    CSMaskDirective,
    CommonUiPartialsModule,
    EffectsModule.forFeature(offerSaverEffects),
    HorizontalCommodityOfferComponent,
    VerticalCommodityOfferComponent,
    MixedCommodityOfferComponent,
  ],
  declarations: [AcquisitionCommodityOfferContainerComponent],
  exports: [],
  providers: [OfferMailer],
})
export class BecomeACustomerOfferModule {}
